
import Vue, { PropType } from 'vue'
import MenuEntity, { IMenuProps } from '@/entities/Menu'
import UnreadEntity from '@/entities/Unread'

const component = Vue.extend({
  props: {
    value: {
      type: Object as PropType<IMenuProps>,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    m(value?: IMenuProps): MenuEntity {
      return new MenuEntity(value)
    },
    unread(value: string): number {
      return new UnreadEntity(this.App.notification.unread).unread(value)
    },
    click(value: IMenuProps) {
      this.$router.push(this.m(value).to)
    }
  }
})
Vue.component('AMenuItem', component)
export default component
